import { render, staticRenderFns } from "./course-chapter-editor.vue?vue&type=template&id=7d53179e&"
import script from "./course-chapter-editor.vue?vue&type=script&lang=js&"
export * from "./course-chapter-editor.vue?vue&type=script&lang=js&"
import style0 from "./course-chapter-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports